import isEqual from "lodash.isequal";
import type { QuizFieldType } from "../quiz.types";
import { makeQuizQuestionInputKey } from "./makeQuizQuestionInputKey";

/**
 * Filters quiz fields based on conditional logic.
 * Evaluates question_logic to determine which fields should be visible
 * based on the current form values.
 */
export function filterFieldsByQuestionLogic(
  fields: QuizFieldType[],
  values: Record<string, unknown>
): QuizFieldType[] {
  return fields.filter((field) => {
    if (!("question_logic" in field) || !field.question_logic) return true;

    const { depends_on, operator, value } = field.question_logic;

    const dependentValue = values[makeQuizQuestionInputKey(depends_on)];

    switch (operator) {
      case "=":
        return (
          dependentValue === value ||
          isEqual(dependentValue, [value]) ||
          (Array.isArray(dependentValue) && dependentValue.includes(value))
        );
      case "!=":
        return dependentValue !== value;
      case ">":
        return (dependentValue as number) > (value as number);
      case "<":
        return (dependentValue as number) < (value as number);
      case ">=":
        return (dependentValue as number) >= (value as number);
      case "<=":
        return (dependentValue as number) <= (value as number);
      default:
        return true;
    }
  });
}

